import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output, Signal, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FilesService } from '../../services/file.service';
import { TwoHandsNumberDataSet } from '../../services/model';
import { NumbersOnlyDirective } from '../../directives/numbers-only.diretive';
import { startWith } from 'rxjs';

type TwoHandsRowHtml = TwoHandsNumberDataSet & {
  controlRightName: string;
  controlLeftName: string;
};

@Component({
  selector: 'app-dynamic-table-input',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatIconModule,
    NumbersOnlyDirective,
  ],
  templateUrl: './dynamic-table-input.component.html',
  styleUrl: './dynamic-table-input.component.scss',
})
export class DynamicTableInputComponent implements OnInit {
  public filesService: FilesService = inject(FilesService);
  private fb: UntypedFormBuilder = inject(UntypedFormBuilder);
  @Input() title: string | undefined = '';
  @Input() data: Array<TwoHandsNumberDataSet> = [];
  @Input() note: string = '';
  @Input() manual: string | undefined = '';
  @Input() startTabIndex: number = 0;
  @Input() isTwoSided = true;
  @Output() inputData = new EventEmitter<{
    data: Array<TwoHandsNumberDataSet>;
    note: string;
    hasError: boolean;
    hasMissingInputs: boolean;
  }>(true);
  dataHtml: Array<TwoHandsRowHtml> = [];
  form: FormGroup = new FormGroup({});
  private valueChanges: Signal<unknown> | undefined;
  // private formDataEffect = effect(() => {
  //   console.log('value Changes', this.valueChanges());

  //   this.inputData.emit(this.valueChanges());
  // });

  // fileList = from(this.filesService.getFileList(''));

  constructor(private injector: Injector) {}

  ngOnInit() {
    this.form = this.fb.group({
      ...this.data
        .flatMap(row => {
          return [
            { [row.name + '_left']: [row.valueLeft, [Validators.min(row.min ?? 0), Validators.max(row.max ?? 100)]] },
            { [row.name + '_right']: [row.valueRight, [Validators.min(row.min ?? 0), Validators.max(row.max ?? 100)]] },
          ];
        })
        .reduce((prev, current) => {
          const [key] = Object.keys(current);
          const value = current[key];
          prev[key] = value;
          return prev;
        }, {}),
      note: [this.note],
    });

    this.valueChanges = toSignal(this.form.valueChanges.pipe(startWith(this.form.value)), { injector: this.injector });

    effect(
      () => {
        const formData = this.valueChanges!() as object;
        let hasMissingInputs = false;
        if (formData) {
          const newData: Array<TwoHandsNumberDataSet> = [];
          this.data.forEach((row, zeroBasedIndex) => {
            const index = zeroBasedIndex + 1;
            const propLeft = 'test' + index + '_left';
            const propRight = 'test' + index + '_right';
            const valueLeft: number | null = this.hasDynamicProperty(formData, propLeft)
              ? (formData[propLeft] as number)
              : null;
            const valueRight: number | null = this.hasDynamicProperty(formData, propRight)
              ? (formData[propRight] as number)
              : null;
            if (valueRight === null && valueLeft === null) {
              hasMissingInputs = true;
            }
            newData.push({
              ...row,
              valueLeft,
              valueRight,
              // valueLeft: this.getMinMAxValue(valueLeft, row),
              // valueRight: this.getMinMAxValue(valueRight, row),
            });
          });
          const note: string = this.hasDynamicProperty(formData, 'note') ? formData['note'] : '';
          const hasError = this.form.status === 'INVALID' ? true : false;
          this.inputData.emit({ note, data: newData, hasError, hasMissingInputs });
        }
      },
      { injector: this.injector }
    );

    this.dataHtml = this.data.map(row => {
      return { ...row, controlLeftName: row.name + '_left', controlRightName: row.name + '_right' };
    });
  }

  hasDynamicProperty(obj: any, propName: string): obj is { [key: string]: any } {
    return typeof obj === 'object' && obj !== null && propName in obj;
  }

  // getMinMAxValue(value: number | null, row: TwoHandsNumberDataSet): number | null {
  //   if (row.min !== null && row.min !== undefined && row.max !== null && row.max !== undefined && value !== null) {
  //     if (value > row.max) {
  //       return row.max;
  //     } else if (value < row.min) {
  //       return row.min;
  //     } else {
  //       return value;
  //     }
  //   } else {
  //     return value;
  //   }
  // }

  // onInputChange($event: any, controlName: string, row: TwoHandsNumberDataSet) {
  //   console.log('onInputChange', row);
  //   return;

  //   if ($event.target) {
  //     if ($event.target.value === '') {
  //       return;
  //     } else {
  //       console.log('$event.target.value', $event.target.value);
  //       $event.target.value = this.getMinMAxValue(Number($event.target.value), row);
  //       this.form.controls[controlName].patchValue(this.getMinMAxValue(Number($event.target.value), row));
  //     }
  //   }
  // }
}
